import { t } from 'i18next';
import { MANTY_STATUS } from 'routes/HumanResourcesModule/business/definitions';
import { TEXT_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { hrPositionMappingValueGetter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';

export const getMantyStatusColumn = () => ({
    ...TEXT_FILTER,
    headerName: t(`humanResources.settings.${MANTY_STATUS}`),
    field: MANTY_STATUS,
    enableRowGroup: true,
    filterValueGetter: hrPositionMappingValueGetter(MANTY_STATUS),
    valueGetter: hrPositionMappingValueGetter(MANTY_STATUS),
    hide: true,
});
